import { render } from "./CrudModeloVeiculoTrator.vue?vue&type=template&id=2d568eaa"
import script from "./CrudModeloVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CrudModeloVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script